exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-103ff060]{margin-top:20px}.helpdesk-chat-link[data-v-103ff060]{font-size:16px;border:none;background:none;cursor:pointer;padding:0;color:#0696d7;text-decoration:underline}", ""]);

// exports
